import request from '@/utils/request'

/** 月度考勤矩阵（门店排班展示打卡/请假） */
export function getAttendanceMonthReport(data) {
  return request({
    url: '/api/Extend/LqAttendanceRecord/MonthReport',
    method: 'get',
    data
  })
}
